import { render, staticRenderFns } from "./AppointmentsList.vue?vue&type=template&id=55ab665e&"
import script from "./AppointmentsList.vue?vue&type=script&lang=js&"
export * from "./AppointmentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports